import React from "react";
import {
  GdkAddressAutoComplete,
  IAddressAutoCompleteOptions,
} from "@gdk/address-auto-complete";
import { SearchField } from "./SearchField";

declare global {
  interface Window {
    GDKAddressAutoComplete: GdkAddressAutoComplete;
  }
}

export const AddressAutoCompleteForm = () => {
  React.useEffect(() => {
    const instantiationObject: IAddressAutoCompleteOptions = {
      content: "#addressAutoComplete",
      apiKey: "prj_test_pk_442478703bf935fd048827d898d348472d862c53",
      onSelectAddress: () => {
        const addressData = window.GDKAddressAutoComplete.getAddressData() as { addressLabel?: string };
        let agreeButton = document.getElementById("cutover-address-collection-button-agree") as HTMLElement;
        let searchBox = document.getElementById("search-field-wrapper") as HTMLElement;
        let errorMessage = document.getElementById("search-field-error-message") as HTMLElement;

        (document.getElementById("address_1") as HTMLElement).setAttribute("disabled", "true");
        
        if (addressData.addressLabel) {
          if ((addressData.addressLabel.toLowerCase()).includes("po box") || (addressData.addressLabel.toLowerCase()).includes("p.o. box")) {
            agreeButton.setAttribute("disabled", "true");
            agreeButton.classList.add("form-field--error");
            searchBox.classList.add("form-field--error");
            errorMessage.style.display = "block";
          }
          else {
            agreeButton.removeAttribute("disabled");
            agreeButton.classList.remove("form-field--error");
            searchBox.classList.remove("form-field--error");
            errorMessage.style.display = "none";
          }
        }
      },
    };

    window.GDKAddressAutoComplete = new GdkAddressAutoComplete(
      instantiationObject,
    );
  }, []);

  return (
    <div className={"container"}>
      <div className="row">
        <div className="col-lg-12 address-form">
          <form className="auto-complete-form">
            <div className="address-auto-complete" id="addressAutoComplete">
              <SearchField
                id={"address-search-field"}
                ariaLabel={"Enter address"}
                size={55}
                label={"Search for your address"}
                classNames={"address-search-field"}
                placeHolder={"Enter your address"}
              />
              <div className="search-field-error-message" id="search-field-error-message" style={{display: "none"}}>A street address is required for shipping. PO Boxes are invalid.</div>
              <div className="row">
                <div className="form-field">
                  <label htmlFor="address_1" className="text">
                    Street Address
                  </label>
                  <input
                    id={"address_1"}
                    className="address_1"
                    name="route"
                    type="text"
                    size={35}
                    placeholder=""
                    disabled={true}
                  />
                </div>

                <div className="form-field">
                  <label htmlFor="address_2" className="text">
                    Unit Number
                  </label>
                  <input
                    id={"address_2"}
                    className="address_2"
                    name="route"
                    type="text"
                    size={15}
                    placeholder=""
                  />
                </div>
                <div className="form-field">
                  <label htmlFor="postal_code" className="text">
                    Zip Code
                  </label>
                  <input
                    id={"postal_code"}
                    className="postal_code"
                    name="postal_code"
                    type="text"
                    size={5}
                    placeholder=""
                  />
                </div>
              </div>
              {
                <div style={{ display: "none" }}>
                  <div className="form-field">
                    <label htmlFor="apt_num" className="text">
                      Apartment Number
                    </label>
                    <span id="field8desc" className="form-descriptive-copy">
                      Optional
                    </span>
                    <input
                      name="route"
                      className="apt_num"
                      type="text"
                      size={5}
                      placeholder=""
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="locality" className="text">
                      City
                    </label>
                    <input
                      id={"locality"}
                      className="locality"
                      name="locality"
                      type="text"
                      size={25}
                      placeholder=""
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="administrative_area_level_1" className="text">
                      State
                    </label>
                    <input
                      id={"administrative_area_level_1"}
                      className="administrative_area_level_1"
                      name="administrative_area_level_1"
                      type="text"
                      size={3}
                      placeholder=""
                    />
                  </div>

                  <div className="form-field">
                    <label htmlFor="country" className="text">
                      Country
                    </label>
                    <input
                      id={"country"}
                      className="country"
                      name="country"
                      type="text"
                      size={30}
                      placeholder=""
                    />
                  </div>
                </div>}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
